import React, { useEffect, useState } from 'react';
import { connect } from 'unistore/react';
import { Switch, Case, Default } from '@buyhatke/react-ui';

import { SEO, Link } from '@components';

import SpotMargin from '@appComponents/bb-fees/spotMargin';
import CryptoFees from '@appComponents/bb-fees/cryptoFees';
import InrFees from '@appComponents/bb-fees/inrFees';

import { GetURLParams } from '@utils/customLib';
import { allDynamicFee, slabsList } from '@utils/cred';
import { disabledThingiesActions } from '@utils/store/actions';

const Fees = ({ fdContext, slabContext, __getDisabledThingies }) => {
	const [tabs, setTabs] = useState();
	const urlParam = GetURLParams().getParams('type') || 'spot';

	useEffect(() => {
		__getDisabledThingies();
	}, []);

	useEffect(() => {
		const tabkey = urlParam.toLowerCase();
		switch (tabkey) {
			case 'crypto':
			case 'inr': {
				setTabs(tabkey);
				break;
			}
			default: {
				setTabs('spot');
			}
		}
	}, [urlParam]);

	const tabLinks =
		'outline-none focus:outline-none p-4 border-b-4 whitespace-nowrap p-4 uppercase text-sm text-center';

	return (
		<>
			<SEO
				title="Bitbns Fees - Lowest cryptocurrencies trading fee in India"
				description="Deposit, withdrawal & trade cryptocurrencies in INR at lowest trading fee"
				url="https://bitbns.com/fees"
			/>
			<div className="bg-primary text-white py-8 container">
				<h1 className="font-bold text-center my-0 text-3xl">
					Fee Structure
				</h1>
			</div>
			<div className="w-full bg-white">
				<div className="bg-gray-200 overflow-auto">
					<div className="flex max-w-6xl mx-auto u-scrollBarSmall--light">
						<Link href="/fees/">
							<a
								type="button"
								className={` flex-grow ${tabLinks} ${
									tabs === 'spot'
										? 'border-primary100 bg-white'
										: 'bg-gray-200 border-transparent'
								}`}
							>
								Spot, Derivatives &amp; Margin trading
							</a>
						</Link>
						<Link href="/fees/?type=crypto">
							<a
								type="button"
								className={` flex-grow ${tabLinks} ${
									tabs === 'crypto'
										? 'border-primary100 bg-white'
										: 'bg-gray-200 border-transparent'
								}`}
							>
								Crypto Withdrawal
							</a>
						</Link>
						<Link href="/fees/?type=inr">
							<a
								type="button"
								className={` flex-grow ${tabLinks} ${
									tabs === 'inr'
										? 'border-primary100 bg-white'
										: 'bg-gray-200 border-transparent'
								}`}
							>
								INR’ Deposit &amp; Withdrawal
							</a>
						</Link>
					</div>
				</div>
				<div className="pt-24 pb-16 px-8 max-w-6xl mx-auto h-full text-gray-900">
					<Switch>
						<Case condition={tabs === 'crypto'}>
							<CryptoFees fdContext={fdContext} />
						</Case>
						<Case condition={tabs === 'inr'}>
							<InrFees />
						</Case>
						<Default>
							<SpotMargin slabContext={slabContext} />
						</Default>
					</Switch>
				</div>
			</div>
		</>
	);
};

export default connect('balanceCoins', disabledThingiesActions)(Fees);

export async function getStaticProps() {
	// const content = await markdownToHtml((post.content as string) || '');

	const { data, data_bsc, data_matic } = await allDynamicFee('full');
	const { data: slabContext } = await slabsList('full');

	return {
		props: {
			fdContext: {
				fee_erc20: data,
				fee_bep20: data_bsc,
				fee_matic20: data_matic,
			},
			slabContext,
		},
	};
}
